import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';
import Tappable from 'react-tappable/lib/Tappable';

const TappableLink = ({ children, className, router, to }) => {
  return (
    <Tappable className={className} onTap={() => router.push(to)}>
      {children}
    </Tappable>
  );
};

TappableLink.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  router: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired
};

export default withRouter(TappableLink);



// WEBPACK FOOTER //
// ./src/components/TappableLink.js